<template>
    <div class="estate-thumbs">
        <div v-if="this.images === null" class="loading-overlay">
            <div class="loading">
                <div class="hourglass">
                    <div class="hourglass-top">
                        <div class="sand-top">
                        </div>
                    </div>
                    <div class="hourglass-bottom">
                        <div class="sand-bottom">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else-if="this.images.length !== 0" class="thumbs-wrapper">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div v-for="image in this.images" class="swiper-slide">
                        <img :src="'/image/thumbnail/' + image">
                    </div>
                </div>

                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
        </div>

        <div v-else class="thumbs-wrapper-error">
            <h2>Nebyly nalezeny žádné fotky</h2>
        </div>
    </div>
</template>

<script>
    import Swiper from 'swiper/swiper-bundle';

    export default {
        name: "estate-thumbnails",

        props: ['record'],

        data: function() {
            return {
                images: null,
                swiper: null
            }
        },

        watch: {
            images: {
                deep: true,

                handler: function(value, old) {
                    setTimeout(function () {
                        if (value.length > 0) {
                            this.swiper = new Swiper('.swiper-container', {
                                direction: 'horizontal',
                                loop: true,
                                slidesPerView: 'auto',
                                observer: true,
                                observeParents: true,
                                parallax:true,

                                navigation: {
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev',
                                },
                            });
                        }
                    },100)
                }
            }
        },

        created: function () {
            let self = this;
            $.ajax({
                url: "/realty/ajax/images/" + this.record,
            }).done(function(data) {
                self.images = JSON.parse(data);
            });
        }
    }
</script>

<style scoped>
    .estate-thumbs {
        position: relative;
        min-height: 125px;
        margin: 10px -15px;
    }

    .loading-overlay {
        position: absolute;
    }

    .thumbs-wrapper {
        max-height: 125px;
        overflow: hidden;
        white-space: nowrap;
    }

    .thumbs-wrapper img {
        display: inline-block;
        height: 125px;
        width: auto;
    }

    .thumbs-wrapper-error {
        display: flex;
        height: 125px;
        justify-content: center;
        align-items: center;
        background-color: rgba(0,0,0,.05);
    }

    .swiper-slide {
        width: auto !important;
        padding-right: 5px;
    }

    .swiper-button-prev, .swiper-button-next {
        width: calc(20px / 44 * 27);
        height: 20px;
        margin-top: calc(-1 * 20px / 2);
        color: #20cba3 !important;
    }

    .swiper-button-prev:after, .swiper-button-next:after {
        font-size: 20px;
    }
</style>
